export const LOAD_PAGE = 'LOAD_PAGE'
export const LOAD_PAGE_REQUEST = 'LOAD_PAGE_REQUEST'


/** WEBPACK FOOTER **
 ** ./src/actions/constants.js
 **/